import { Component, OnInit, Output, Input, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FeedbackModel } from '../../model/feedback-model';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-feedback-modal',
    templateUrl: './feedback-modal.component.html',
    styleUrls: ['./feedback-modal.component.scss']
})

export class FeedbackModalComponent implements OnInit, AfterViewInit {
    isValidEnail: boolean = true;
    emailErrorMessage: string;
    feedbackSent: boolean = false;

    public feedbackModel: FeedbackModel;
    public categories: string[];
    public selectedCategoryId: number;

    @Input() selectedFeatures: string;
    @Output() closeModal: EventEmitter<FeedbackModel> = new EventEmitter<FeedbackModel>();
    @ViewChild("feedbackClose") feedbackClose: ElementRef;

    constructor(private translate: TranslateService,
        private globalService: GlobalService) { }

    ngOnInit() {
        this.emailErrorMessage = "";
        this.selectedCategoryId = 0;
        this.categories = [];

        this.translate.get('feedback.Page has a color problem').subscribe(item => {
            this.categories.push(item);
        });

        this.translate.get('feedback.Page has a navigational problem').subscribe(item => {
            this.categories.push(item);
        });

        this.translate.get('feedback.Assistive tool problem on page').subscribe(item => {
            this.categories.push(item);
        });

        this.feedbackModel = {
            type: "",
            email: "",
            notifyWhenFix: false,
            content: "",
            pageUrl: this.globalService.siteUrl,
            langCode: this.globalService.language,
            profileID: "mySettings"
        }

        this.globalService.allowFocusOnMenu(false);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.feedbackClose.nativeElement != null)
                    this.feedbackClose.nativeElement.focus();
        }, 50)  
    }

    
    isMobile(){
        return this.globalService.isMobile;
    }

    onClick($event) {
        if ($event.keyCode === 27) {
            $event.stopPropagation();
            this.closeFeedkbackModal();
        }
    }

    isEmailValid() {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.feedbackModel.email).toLowerCase());
    }

    isNotifyCheckboxDisabled() {
        if (this.globalService.settings && this.globalService.settings.mainMenu && this.globalService.settings.mainMenu.features &&
            this.globalService.settings.mainMenu.features.feedback) {
            return this.globalService.settings.mainMenu.features.feedback.disableNotifyCheckbox || false;
        }
        return false;
    }

    closeFeedkbackModal() {
        this.globalService.allowFocusOnMenu(true);
        this.closeModal.emit();
        document.getElementById("openFeedbackBtn").focus();
    }

    onSubmit() {
        if (this.isEmailValid()) {
            this.feedbackModel.type = this.categories[this.selectedCategoryId];
            if (this.selectedFeatures) {
                this.feedbackModel.profileID = this.selectedFeatures;
            }
            else {
                this.feedbackModel.profileID = "off";
            }

            this.feedbackSent = true;
            this.globalService.allowFocusOnMenu(true);
            //this.closeModal.emit(this.feedbackModel);
        }
        else {
            if (this.feedbackModel.email) {
                this.emailErrorMessage = "feedback.Invalid email";
            }
            else {
                this.emailErrorMessage = "feedback.Mandatory field";
            }
        }
    }

    closeThankYouModal() {
        this.closeModal.emit(this.feedbackModel);
        this.globalService.allowFocusOnMenu(true);
        document.getElementById("openFeedbackBtn").focus();
    }
}
